<template>
  <modal :show.sync="visible" header-classes="justify-content-center" modal-classes="modal-lg">
    <template slot="header">
      <h4 class="modal-title promo-title">Limited Spaces Available</h4>
    </template>
    <div class="text-center">
      <p class="promo-badge">Exclusive Offer</p>
      <h3 class="promo-heading">Fully Managed Service</h3>
      <h2 class="promo-price">£80 <small>per month</small></h2>
      <p class="promo-desc">We have a limited number of spaces available for landlords looking to sign up to our <strong>Fully Managed Service</strong>. Don't miss out — secure your place today and enjoy a completely hands-off letting experience.</p>
      <ul class="promo-features text-left">
        <li><i class="now-ui-icons ui-1_check text-success"></i> Fully vetted tenants</li>
        <li><i class="now-ui-icons ui-1_check text-success"></i> Legal cover throughout tenancy</li>
        <li><i class="now-ui-icons ui-1_check text-success"></i> Free property inventory</li>
        <li><i class="now-ui-icons ui-1_check text-success"></i> Rent protection included</li>
        <li><i class="now-ui-icons ui-1_check text-success"></i> Guaranteed rent paid on time</li>
        <li><i class="now-ui-icons ui-1_check text-success"></i> Free eviction service</li>
      </ul>
    </div>
    <template slot="footer">
      <a href="/contactus" class="btn btn-primary btn-lg btn-block">Sign Up Now</a>
      <button class="btn btn-link" @click="visible = false">Maybe later</button>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@/components";

export default {
  name: "promo-modal",
  components: { Modal },
  data() {
    return { visible: false };
  },
  mounted() {
    setTimeout(() => { this.visible = true; }, 1000);
  },
};
</script>

<style scoped>
.promo-badge {
  display: inline-block;
  background-color: #BAA583;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 4px 14px;
  border-radius: 20px;
  margin-bottom: 12px;
}
.promo-title { font-weight: 700; color: #333; }
.promo-heading { font-weight: 600; margin: 0 0 4px; }
.promo-price { color: #BAA583; font-weight: 700; margin-bottom: 16px; }
.promo-price small { font-size: 1rem; color: #888; }
.promo-desc { color: #555; margin-bottom: 20px; }
.promo-features { list-style: none; padding: 0; margin-bottom: 0; }
.promo-features li { padding: 5px 0; font-size: 0.95rem; }
.promo-features i { margin-right: 8px; }
</style>
